import React from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { Modal, Backdrop, Fade, Button } from "@material-ui/core";

const MapModalForView = ({ open, handleClose, currentLocation, address }) => {
  const location = {
    lat: parseFloat(currentLocation?.lat) || 29.3759,
    lng: parseFloat(currentLocation?.long) || 47.9774,
    address: currentLocation?.address || "Address not specified",
  };

  const mapContainerStyle = {
    height: "400px",
    width: "100%",
  };

  const isGoogleMapsLoaded = window.google?.maps;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Fade in={open}>
        <div
          style={{
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "8px",
            width: "80%",
            maxWidth: "800px",
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h3>LOCATION</h3>

          <div style={{ marginTop: "15px" }}>
            <p>
              <strong>Address:</strong> {address || "No address specified"}
            </p>
          </div>

          {isGoogleMapsLoaded ? (
            <GoogleMap
              mapContainerStyle={mapContainerStyle}
              center={{ lat: location.lat, lng: location.lng }}
              zoom={15}
              options={{ disableDefaultUI: true }}
            >
              <Marker position={{ lat: location.lat, lng: location.lng }} />
            </GoogleMap>
          ) : (
            <div style={{ height: "400px", display: "flex", alignItems: "center", justifyContent: "center", background: "#f5f5f5", border: "1px solid #ddd", borderRadius: "4px" }}>
              <p>Loading map...</p>
            </div>
          )}

          <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginTop: "15px" }}>
            <Button
              onClick={() =>
                window.open(
                  `https://www.google.com/maps/dir/?api=1&destination=${location.lat},${location.lng}`,
                  "_blank",
                  "noopener,noreferrer"
                )
              }
              variant="contained"
              style={{ backgroundColor: "#FEBA00", color: "#1a1a1a", fontWeight: 600 }}
            >
              GET DIRECTIONS
            </Button>
            <Button onClick={handleClose} variant="contained" color="primary">
              CLOSE
            </Button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default MapModalForView;
